import {GameXpHighlightsState} from '../../reducers/fortnite-game/gameXpHighlights.reducer';

export const getGameXpHighlightsState = (state): GameXpHighlightsState => {
    return state.get('gameXpHighlights').toJS();
};
